import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { Grid } from "@material-ui/core";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CircularProgress from '@material-ui/core/CircularProgress';

import { styles } from './styles';
import Apis from '../../../../../utils/Apis'

class NewType extends Component {
    state = {
        name: '',
        instruction: ''
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.registered === 1) {
            this.props.onClose();
            return;
        }
        if (nextProps.registered === -1 && nextProps.error.body !== undefined) {
            this.props.onAlertMessage("error", nextProps.error.body.message);
            return;
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };


    handleClickShowConfirmPassword = () => {
        this.setState(state => ({ showConfirmPassword: !state.showConfirmPassword }));
    }

    onClose = () => {
        this.props.onClose();
    }

    onCreateNew = () => {
        const { name, instruction, requesting } = this.state;
        if (requesting) {
            return;
        }

        if (name === '') {
            this.props.onAlertMessage("error", "Please input name to create new type!");
            return;
        }
        if (instruction === '') {
            this.props.onAlertMessage("error", "Please input instruction to create new type!");
            return;
        }

        this.setState({ requesting: true });
        Apis.register_type({ 'name': name, 'instruction': instruction })
            .then(res => {

                this.setState({ requesting: false });
                let data = res.data;
                let status = data.status;
                if (status === 'success') {
                    this.props.onAlertMessage("success", "New type was successfully created.");
                    this.props.onDoneRegister();
                    return
                } else {
                    this.props.onAlertMessage("error", data.message);
                }

            })
            .catch(err => {
                this.setState({ requesting: false });
                this.props.onAlertMessage("error", err.response.data.message);
            })
    }

    render() {
        const { classes } = this.props;
        const { open } = this.props;
        const { requesting, instruction } = this.state;
        return (
            <div>
                <Dialog
                    open={open}
                    onClose={this.onClose}
                    aria-labelledby="signup-dialog-title"
                    aria-describedby="signup-dialog-description">
                    <DialogTitle id="signup-dialog-title"
                        className={classes.title}>
                        {"Create New Type?"}
                    </DialogTitle>

                    <DialogContent>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems='center'
                            className={classes.main_container}>

                            <Grid container
                                direction="column">
                                <FormControl
                                    className={classes.formControl}>
                                    <InputLabel shrink htmlFor="ibName" className={classes.inputlabel}>
                                        Name
                                    </InputLabel>
                                    <OutlinedInput
                                        id="ibName"
                                        placeholder="Type Name"
                                        classes={{
                                            root: classes.inputbaseRoot,
                                            input: classes.inputbaseInput,
                                        }}
                                        value={this.state.name}
                                        onChange={this.handleChange('name')}
                                        fullWidth
                                    />
                                </FormControl>
                                <FormControl
                                    className={classes.formControl}>
                                    <InputLabel shrink htmlFor="ibInstruction" className={classes.inputlabel}>
                                        Instruction
                                    </InputLabel>
                                    <TextField
                                        multiline
                                        rows={2}
                                        style={{textAlign: 'left', height: '100px'}}
                                        placeholder='Type instruction'
                                        InputProps={{
                                            classes: {
                                              input: classes.resize,
                                            },
                                          }}
                                        margin="normal"
                                        value={instruction}
                                        onChange={this.handleChange('instruction')}
                                        variant="outlined"
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <div className={classes.wrapper}>
                            <Grid item container direction="column" justify="center" alignItems="stretch">
                                <Button color="primary" variant="contained" className={classes.btnNewAccount}
                                    onClick={this.onCreateNew}>
                                    Create Type
                                </Button>
                            </Grid>
                            {requesting && <CircularProgress size={24} className={classes.buttonProgress} />}
                        </div>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

NewType.propTypes = {
    classes: PropTypes.object.isRequired,
};

// const RegisterlWrapped = withStyles(styles)(Register);


export default withStyles(styles)(NewType);
